module.exports = __webpack_public_path__ + "static/triangular-envelope-a19e63abb4cbd4437558ac72cd15e83e.png";